export default __webpack_public_path__ + "static/media/abp.c9d59f70.webp";